<template>
    <div class="boxs">
        <div class="seachBox flex" @keydown="searchKey">
            <div class="seachList" style="display: none;"><span class="name">客户名称：</span>
              <a-select
                  placeholder="请输入客户名称"
                  v-model="seach.a_customer_id" class="seachs"
                  :default-active-first-option="false"
                  :filter-option="false"
                  :not-found-content="null"
                  :options="options"
                  :show-arrow="false"
                  show-search
                  @change="handleChange"
                  @search="handleSearch"
              >
              </a-select>
<!--       @change="roomChange"          <a-select-->
<!--                        show-search-->
<!--                        option-filter-prop="children"-->
<!--                        :filter-option="filterOption"-->
<!--                        @change="handleChange"-->
<!--                        placeholder="请输入客户名称"-->
<!--                        v-model="seach.a_customer_id" class="seachs" allowClear-->
<!--                >-->
<!--                    <a-select-option :value="item.id" v-for="item in seachList.name">-->
<!--                        {{item.company}}-->
<!--                    </a-select-option>-->
<!--                </a-select>-->
            </div>
            <div class="seachList"><span class="name">分类：</span>
                <!--                <a-select v-model="seach.category_id" class="seachs" allowClear>-->
                <!--                    <a-select-option :value="item.value" v-for="item in seachList.class">-->
                <!--                        {{item.name}}-->
                <!--                    </a-select-option>-->
                <!--                </a-select>-->

                <a-tree-select placeholder="请选择"
                               :replaceFields="replaceFields"
                               :tree-data="seachList.class"
                               v-model="seach.category_id" class="seachs" allowClear dropdownClassName="replaceFields"
                >
                    <!--    <span  slot-scope="{ name, id }" style="color: #08c">-->
                    <!--      {{ name }}-->
                    <!--    </span>-->
                </a-tree-select>
            </div>
            <div class="seachList"><span class="name">关键词：</span>
                <a-input placeholder="请输入案例名称" class="seachs" v-model="seach.name"/>
            </div>
            <div class="seachList">
              <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
                查询
            </a-button>
              <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button>
            </div>
            <div class="seachList no"></div>
        </div>
        <!-- <a-alert :message=message type="info"  v-if="!message==''" style="margin-bottom: 10px"/> -->
        <div style="margin-bottom: 12px">
<!--            <a-button class="top_btn" type="primary" @click="()=>{visible = true; title='批量翻译' ;this.editId=''; }">-->
<!--                批量翻译-->
<!--            </a-button>-->
            <a-button class="top_btn" type="primary" :disabled="!hasSelected" @click="()=>{  visibleForm = true; titleForm='批量翻译' }">
                批量翻译
            </a-button>
          <a-button class="top_btn" type="primary" :disabled="!hasSelected" @click="()=>{  visibleAiForm = true; titleForm='AI翻译' }">
            AI翻译
          </a-button>
          <a-button class="top_btn" type="primary" :disabled="!seach.a_customer_id" @click="openImportTransModal()">
            导入翻译
          </a-button>
          <a-button class="top_btn" type="primary" :disabled="!hasSelected" @click="aichange()">
            AI改写
          </a-button>
            <span style="margin-left: 8px">
              <template v-if="hasSelected">
                {{ `选中 ${product_ids.length} 项` }}
              </template>
            </span>
        </div>
        <a-table :columns="columns" :data-source="data" :pagination="pagination" rowKey="id" :loading="loadingtable"
                 :row-selection="{ selectedRowKeys: product_ids, onChange: onSelectChange }" v-if="data.length>0">
          <span slot="thumb" slot-scope="text, record"><img :src="record.thumb" alt="" style="width: 100%;display: block"></span>
          <span slot="category" slot-scope="text, record"><i v-for="(item,index) in record.category">{{ item }}</i></span>
        </a-table>
        <a-empty v-else  :description="description" />
        <NewForm :visible="visibleForm" :title="titleForm" :productids="product_ids" :customerid="seach.a_customer_id"
                 @changVisible=" () => { this.visibleForm = false;  this.getList(this.pageNum);this.getCustomerInfo()}  "/>
      <AiNewForm :visible="visibleAiForm"   :productids="product_ids" :customerid="seach.a_customer_id"
                 @changVisible=" () => { this.visibleAiForm = false;  this.getList(this.pageNum);this.getCustomerInfo()}  "/>
        <!-- 导入翻译 -->
        <ImportTranslation ref="importTranslationRef" :customerid="seach.a_customer_id" :importTransData="importTransData" @importFinsh="importTransFinsh"></ImportTranslation>
        <!-- 导入翻译完成弹窗 -->
        <ImportTransFinish ref="importTransFinishRef" @changVisible="() => { this.getList(this.pageNum);this.getCustomerInfo()} "></ImportTransFinish>
    </div>
</template>

<script>
import {debounce} from "../../../../utils/utils"
    import API from "../api";
    import NewForm from "./newForm"
import AiNewForm from "./aiNewForm.vue"
import ImportTranslation from "../../comp/import-translation/index.vue"
import ImportTransFinish from "../../comp/import-translation-finish/index.vue"
    const columns = [
        {
            title: "图片",
            dataIndex: "thumb",
            ellipsis: true,
            width: "150px",
            key: "thumb",
            scopedSlots: {customRender: "thumb"}
        },
        {
            title: "案例名称",
            dataIndex: "name",
            ellipsis: true,
            key: "name",
            scopedSlots: {customRender: "name"}
        },
        {
            title: "案例分类",
            dataIndex: "category_name",
            ellipsis: true,
            key: "category_name",
            scopedSlots: {customRender: "category_name"}
        },
        {
            title: "更新日期",
            dataIndex: "update_time",
            ellipsis: true,
            key: "update_time",
            scopedSlots: {customRender: "update_time"}
        },
    ];
    export default {
        name: "translateAll",
        data() {
            return {
                pageNum:1,
                loadingtable:true,
                description:"请先选择客户",
                message:"",
                replaceFields: {children: 'children', title: 'name', key: 'id',value:"id"},
                visibleImg: false,
                tableImg: "",
                seachList: {
                    name: [],
                    class: []
                },
                seach: {
                  a_customer_id:undefined,
                  name: ""
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true,
                },
                data: [],
                columns,
                selectedRowKeys: [],
                visible: false,
                title: "",
                product_ids:[],
                visibleForm: false,
              visibleAiForm: false,
                titleForm: "",
                loading: true,
              options:[],
              importTransData: {}
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/BatchTranslation/CaseList"; //设置左侧导航2-2 active
        },
        components: {AiNewForm, NewForm, ImportTranslation, ImportTransFinish},
        mounted() {
            // this.getSeachList()
        },
        computed: {
            hasSelected() {
                return this.product_ids.length > 0;
            },
        },
        methods: {
          // debounce(fn, time) {
          //   time = time || 200
          //   // 定时器
          //   let timer = null
          //   return function(...args) {
          //     var _this = this
          //     if (timer) {
          //       clearTimeout(timer)
          //     }
          //     timer = setTimeout(function() {
          //       timer = null
          //       fn.apply(_this, args)
          //     }, time)
          //   }
          // },

          openImportTransModal() {
            this.$refs.importTranslationRef.open(this.seach.a_customer_id, 5)
          },
          importTransFinsh(data) {
              this.$refs.importTransFinishRef.open(data)
          },
          handleSearch: debounce(function (val)   {
            this.handleSearchFn(val)
          }, 300),
            handleSearchFn(val){
            console.log(val)
            this.options=[];
            this.seachList.name=[]
            //下拉模糊查询
            if(val){this.getSeachList(val)}

            // console.log(res);
            // res.data.forEach((item) => {
            //   this.options.push({
            //     value: item.id,
            //     label: item.roomName,
            //   })
            // });
          },
            getSeachList(company){
                API.service.GET_NAME({company}).then(res => {
                    this.seachList.name = res.data.data
                    res.data.data.forEach((item) => {
                          this.options.push({
                            value: item.id,
                            label: item.company,
                          })
                        });
                })
            },
          getCustomerInfo(){
            API.service.GET_CUSTOMER_INFO( {id:this.seach.a_customer_id}).then(res => {
            this.message=`该公司购买字符${res.data.data.translation_set_num}个剩余字符${res.data.data.translation_surplus_num}个`
              // this.getSeachList()
            })
          },
          aichange(){
            let ids=[];
            ids=this.product_ids
            API.service.TRANSLATE_PROSUB( {ids:ids,a_customer_id:this.seach.a_customer_id,type:3,}).then(res => {
              if (res.data.code == 200) {
                this.$message.success(res.data.msg);
                this.getList(1)
              } else {
                this.$message.error(res.data.msg);
              }

            })
          },

            handleChange(value) {
                if(value==undefined)return
                this.loadingtable=true
                this.seachList.class=[]
                API.service.GET_CLASS({a_customer_id:value}).then(res => {
                    this.seachList.class = res.data.data
                })
                this.product_ids=[]
                this.seachList.name.forEach((item,index)=>{
                    if(item.id==value)this.message=`该公司购买字符${item.translation_set_num}个剩余字符${item.translation_surplus_num}个`
                })
                this.getList(1)
            },
            getClass(value){
                API.service.GET_CLASS({a_customer_id:value}).then(res => {
                    this.seachList.class = res.data.data
                })
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            listOrder() {
                let list_orders = []
                let sortListOrder = {id: "", list_order: ""}
                for (let i = 0; i < this.data.length; i++) {
                    sortListOrder.id = this.data[i].id
                    sortListOrder.list_order = this.data[i].list_order
                    list_orders.push(sortListOrder)
                    sortListOrder = {}
                }
                API.service.LIST_ORDER(list_orders).then(res => {
                    this.getList(1)
                })
            },
            resetSeach() {
                this.loading = true
                this.message=""
                this.seach = {
                    a_customer_id: this.seach.a_customer_id,
                    name: ""
                }
                this.seachList.class= []
                this.data=[]
                this.getList(1,"reset")
                this.$emit("resetSeach");
            },
          searchKey(){
            if(event.keyCode == 13){
              this.getList(1)
            }
          },
            getList(page,type) {
              this.loadingtable=true
                let seachData = JSON.parse(JSON.stringify(this.seach))
                if(this.seach.a_customer_id==undefined&&type!="reset"){
                    this.data=[]
                    this.message=""
                    this.description="请先选择客户"
                }
                API.service.GET_LIST({page: page || this.pageNum, ...seachData}).then(res => {
                    this.pageNum=page || this.pageNum
                    if(res.data.code==400 &&type!="reset"){
                        this.$message.destroy()
                        this.$message.error(res.data.msg)
                        return
                    }
                    if(res.data.data.data){
                        this.data = res.data.data.data}else{ this.data=[]}
                    if(this.data.length>0){
                        this.pagination.total = res.data.data.total
                        this.pagination.pageSize = res.data.data.per_page
                        this.pagination.current = res.data.data.current_page
                    }else{
                        this.description="暂无数据"
                    }
                    this.product_ids=[]
                    this.loading=false
                    this.loadingtable=false
                })
            },
            onSelectChange(selectedRowKeys) {
                this.product_ids = selectedRowKeys;
            },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }

</style>
